/* Native links and a stacked-slide fallback remain usable without JavaScript. */
(() => {
 'use strict';
 const instances = new WeakMap();
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 function init(root) {
  if (instances.has(root)) return;
  const slides = Array.from(root.querySelectorAll('[data-v2-slide]'));
  const controls = root.querySelector('[data-v2-controls]');
  if (slides.length < 2) return;
  const buttons = Array.from(root.querySelectorAll('[data-v2-go]'));
  const play = root.querySelector('[data-v2-play]');
  const status = root.querySelector('[data-v2-status]');
  const count = root.querySelector('[data-v2-count]');
  const previous = root.querySelector('[data-v2-prev]');
  const next = root.querySelector('[data-v2-next]');
  const interval = Math.max(5000, Math.min(12000, Number(root.dataset.interval) || 7000));
  const signalController = new AbortController();
  const signal = signalController.signal;
  let active = 0, timer, paused = root.dataset.autoplay !== 'true' || reduced.matches;
  let hovered = false, focused = false, visible = true;
  let startX = 0, startY = 0;
  const pad = value => String(value).padStart(2,'0');
  function updatePlay() {
   if (!play) return;
   play.disabled = reduced.matches;
   play.setAttribute('aria-label', reduced.matches ? 'Automatic rotation disabled for reduced motion' : (paused ? 'Play slideshow' : 'Pause slideshow'));
   play.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
  }
  function schedule() {
   clearTimeout(timer);
   if (paused || hovered || focused || !visible || document.hidden || reduced.matches) return;
   timer = setTimeout(() => show(active + 1,false),interval);
  }
  function show(index,manual = true) {
   const destination = (index + slides.length) % slides.length;
   // Do not move focus into a hidden slide when the current CTA has focus.
   if (slides[active].contains(document.activeElement) && destination !== active) next.focus();
   active = destination;
   slides.forEach((slide,i) => { slide.hidden = i !== active; });
   buttons.forEach((button,i) => button.setAttribute('aria-pressed',String(i === active)));
   count.textContent = `${pad(active+1)} / ${pad(slides.length)}`;
   if (manual) {
    paused = true;
    status.textContent = `Slide ${active+1} of ${slides.length}: ${slides[active].querySelector('h1,h2').textContent}`;
   }
   updatePlay();schedule();
  }
  root.classList.add('is-enhanced');controls.hidden = false;
  show(0,false);
  previous.addEventListener('click',() => show(active-1),{signal});
  next.addEventListener('click',() => show(active+1),{signal});
  buttons.forEach(button => button.addEventListener('click',() => show(Number(button.dataset.v2Go)),{signal}));
  if (play) play.addEventListener('click',() => { paused = !paused;updatePlay();schedule(); },{signal});
  root.addEventListener('mouseenter',() => { hovered = true;schedule(); },{signal});
  root.addEventListener('mouseleave',() => { hovered = false;schedule(); },{signal});
  root.addEventListener('focusin',() => { focused = true;schedule(); },{signal});
  root.addEventListener('focusout',() => setTimeout(() => { focused = root.contains(document.activeElement);schedule(); },0),{signal});
  root.addEventListener('keydown',event => {
   if (!event.target.closest('[data-v2-controls]')) return;
   if (event.key === 'ArrowRight') { event.preventDefault();show(active+1); }
   if (event.key === 'ArrowLeft') { event.preventDefault();show(active-1); }
  },{signal});
  root.addEventListener('touchstart',event => { startX = event.changedTouches[0].clientX;startY = event.changedTouches[0].clientY; },{passive:true,signal});
  root.addEventListener('touchend',event => {
   const dx = event.changedTouches[0].clientX-startX,dy = event.changedTouches[0].clientY-startY;
   if (Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5) show(active+(dx<0?1:-1));
  },{passive:true,signal});
  document.addEventListener('visibilitychange',schedule,{signal});
  const motionChange = () => { if (reduced.matches) paused = true;updatePlay();schedule(); };
  reduced.addEventListener('change',motionChange);
  let observer;
  if (window.IntersectionObserver) {
   observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting;schedule(); },{threshold:.15});
   observer.observe(root);
  }
  const destroy = () => {
   clearTimeout(timer);signalController.abort();
   if (observer) observer.disconnect();
   reduced.removeEventListener('change',motionChange);
   instances.delete(root);
  };
  instances.set(root,{show,destroy});
 }
 const start = parent => parent.querySelectorAll('[data-v2-hero]').forEach(init);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => start(document));else start(document);
 document.addEventListener('shopify:section:load',event => start(event.target));
 document.addEventListener('shopify:section:unload',event => event.target.querySelectorAll('[data-v2-hero]').forEach(root => {const item=instances.get(root);if(item)item.destroy();}));
 document.addEventListener('shopify:block:select',event => {
  const slide=event.target.closest('[data-v2-slide]');if(!slide)return;
  const root=slide.closest('[data-v2-hero]'),instance=instances.get(root);
  if(instance)instance.show(Array.from(root.querySelectorAll('[data-v2-slide]')).indexOf(slide));
 });
})();
